import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgPencilOutline = function SvgPencilOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3839 3.94446C17.8958 3.45633 17.1042 3.45633 16.6161 3.94446L14.3107 6.24993L17.75 9.68927L20.0555 7.38383C20.5436 6.89567 20.5436 6.10418 20.0555 5.61603L18.3839 3.94446ZM16.6893 10.7499L13.25 7.31059L3.86613 16.6944C3.63169 16.9289 3.5 17.2469 3.5 17.5783V20.4999H6.42157C6.7531 20.4999 7.07103 20.3682 7.30545 20.1338L16.6893 10.7499ZM12.7197 5.71959L15.5555 2.88383C16.6294 1.80989 18.3707 1.80987 19.4445 2.88383L21.1161 4.55538C22.19 5.62932 22.19 7.37052 21.1161 8.44446L8.36613 21.1944C7.85039 21.7102 7.15091 21.9999 6.42157 21.9999H2.75C2.33579 21.9999 2 21.6641 2 21.2499V17.5783C2 16.849 2.28974 16.1495 2.80545 15.6338L12.7197 5.71959Z"
  })));
};

export { SvgPencilOutline as ReactComponent };
//# sourceMappingURL=pencil-outline.svg.js.map
